module.exports = __webpack_public_path__ + "static/media/102-shield.b5c0c535.svg";